/*
 * cart-extras.js — SHAMTAM cart micro-feedback.
 *
 * A small, brand-matched toast that confirms add / remove actions (the QA audit flagged
 * "no visual confirmation"). It listens to the theme's own cart events and never touches
 * the cart itself.
 *   • on:cart:add        → "Added to your basket"  (suppressed if the cart drawer opens,
 *                          so we never double up with the drawer's own confirmation)
 *   • on:line-item:change with newQuantity 0 → "Removed from your basket"
 *
 * Copy comes from #cart-extras-config (localisable).
 */
(function () {
  'use strict';
  if (window.__cartExtrasInit) return;
  window.__cartExtrasInit = true;

  var L = {};
  try { var c = document.getElementById('cart-extras-config'); if (c) L = JSON.parse(c.textContent); } catch (e) {}

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function icoCheck() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6.5L9.2 17 4 11.8"/></svg>'; }
  function icoTrash() { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13M10 11v6M14 11v6"/></svg>'; }

  var host = null;
  function ready(fn) { if (document.body) fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function ensureHost() {
    if (host && host.isConnected) return host;
    host = document.createElement('div');
    host.className = 'shx-toasts';
    host.setAttribute('aria-live', 'polite');
    document.body.appendChild(host);
    return host;
  }
  function toast(msg, kind) {
    if (!msg) return;
    ready(function () {
      var h = ensureHost();
      var t = document.createElement('div');
      t.className = 'shx-toast' + (kind ? ' shx-toast--' + kind : '');
      t.innerHTML = '<span class="shx-toast__ic">' + (kind === 'remove' ? icoTrash() : icoCheck()) + '</span><span>' + esc(msg) + '</span>';
      h.appendChild(t);
      requestAnimationFrame(function () { t.classList.add('is-in'); });
      setTimeout(function () {
        t.classList.remove('is-in');
        setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 350);
      }, 2600);
    });
  }

  // When the store opens the cart drawer on add (afterAtc === 'drawer'), the drawer IS
  // the confirmation — don't also toast. Only toast "added" when the page stays put
  // (e.g. quick-add that doesn't open the drawer), so feedback is never doubled.
  var opensDrawer = !!(window.theme && window.theme.settings && window.theme.settings.afterAtc === 'drawer');
  document.addEventListener('on:cart:add', function () {
    if (!opensDrawer) toast(L.added || 'Added to your basket', 'add');
  });

  document.addEventListener('on:line-item:change', function (e) {
    try { if (e.detail && Number(e.detail.newQuantity) === 0) toast(L.removed || 'Removed from your basket', 'remove'); } catch (er) {}
  });
})();
